import React from 'react'

export function HomeIcon(stroke?: string) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.8939 12.1666V7.54328V7.54267C14.8939 7.09779 14.8939 6.87524 14.8398 6.66813C14.7918 6.48451 14.7128 6.31038 14.6062 6.15336C14.486 5.97617 14.3186 5.8296 13.9835 5.53638L9.98346 2.03638C9.36128 1.49197 9.0502 1.21981 8.70009 1.11627C8.3916 1.02504 8.06295 1.02504 7.75446 1.11627C7.40454 1.21975 7.09377 1.49168 6.47227 2.03549L6.47125 2.03638L2.47125 5.53638L2.47046 5.53708C2.13588 5.82983 1.96847 5.97631 1.84829 6.15336C1.74169 6.31038 1.66273 6.48451 1.61475 6.66813C1.56061 6.87534 1.56061 7.09799 1.56061 7.54328V12.1666C1.56061 12.9431 1.56061 13.3313 1.68748 13.6376C1.85663 14.046 2.18128 14.3705 2.58966 14.5396C2.89595 14.6665 3.28423 14.6665 4.0608 14.6665C4.83737 14.6665 5.22546 14.6665 5.53175 14.5396C5.94013 14.3705 6.2645 14.046 6.43365 13.6376C6.56052 13.3313 6.56061 12.9431 6.56061 12.1665V11.3332C6.56061 10.4127 7.3068 9.66649 8.22727 9.66649C9.14775 9.66649 9.89394 10.4127 9.89394 11.3332V12.1665C9.89394 12.9431 9.89394 13.3313 10.0208 13.6376C10.19 14.046 10.5146 14.3705 10.923 14.5396C11.2293 14.6665 11.6176 14.6665 12.3941 14.6665C13.1707 14.6665 13.5588 14.6665 13.8651 14.5396C14.2735 14.3705 14.5978 14.046 14.767 13.6376C14.8939 13.3313 14.8939 12.9431 14.8939 12.1666Z"
                stroke={stroke || 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
